const NAMED_COLOR =
  /^(black|blue|white|red|green|yellow|pink|purple|violet|indigo|orange|brown|grey|gray|navy|beige|cream|ivory|maroon|teal|cyan|magenta|gold|silver|tan|khaki|coral|salmon|lavender|mint|peach|rose|burgundy|charcoal|slate|turquoise|aqua|lime|olive|plum|nude|mauve|blush|sand|camel|chocolate|coffee|gainsboro|linen|azure|crimson|scarlet|fuchsia|lightblue|lightgreen|lightgray|lightgrey|darkblue|darkgreen|darkgray|darkgrey|hotpink|deeppink|skyblue|steelblue|midnightblue|forestgreen|seagreen|darkred|orangered)$/i;

export const isColorAttributeName = (name) =>
  /color|colour/i.test(String(name || '').trim());

const isHexOrRgb = (value) => {
  const s = String(value || '').trim();
  return (
    /^#[0-9a-f]{3,8}$/i.test(s) ||
    /^[0-9a-f]{3,8}$/i.test(s) ||
    /^rgb/i.test(s) ||
    /^hsl/i.test(s)
  );
};

const looksLikeColorWord = (value) => {
  const text = String(value || '').trim();
  if (!text || /^\d+$/.test(text)) return false;
  const compact = text.toLowerCase().replace(/\s+/g, '');
  return NAMED_COLOR.test(compact) || NAMED_COLOR.test(text.toLowerCase().split(/\s+/)[0]);
};

/** Convert stored attribute value to a CSS color for swatches. */
export const parseColorValueToCss = (raw) => {
  const value = String(raw || '').trim();
  if (!value) return '';

  if (value.startsWith('#')) return value;
  if (/^[0-9a-f]{3,8}$/i.test(value)) return `#${value}`;
  if (/^rgb/i.test(value) || /^hsl/i.test(value)) return value;
  if (looksLikeColorWord(value)) return value.toLowerCase().replace(/\s+/g, '');

  return '';
};

export const isValidColorValue = (raw) => Boolean(parseColorValueToCss(raw));

/** Normalize color picker / hex input to #RRGGBB when possible. */
export const normalizeColorValue = (raw, fallback = '#000000') => {
  const css = parseColorValueToCss(raw);
  if (!css) return fallback;
  if (/^#[0-9a-f]{6}$/i.test(css)) return css.toUpperCase();
  if (/^#[0-9a-f]{3}$/i.test(css)) {
    const hex = css.slice(1);
    return `#${hex[0]}${hex[0]}${hex[1]}${hex[1]}${hex[2]}${hex[2]}`.toUpperCase();
  }
  return css;
};

export const parseColorOptionsFromAttributeValues = (items = []) => {
  const colors = [];
  const seen = new Set();

  for (const row of items) {
    const attributeName = String(row.ProductAttributeName || row.AttributeName || '').trim();
    if (!isColorAttributeName(attributeName)) continue;
    if (row.IsActive === false) continue;

    const label = String(row.AttributeValue ?? '').trim();
    if (!label) continue;

    const css = parseColorValueToCss(label);
    if (!css) continue;

    const key = `${label.toLowerCase()}-${css.toLowerCase()}`;
    if (seen.has(key)) continue;
    seen.add(key);

    colors.push({ label, value: css, type: 'color' });
  }

  return colors;
};

export const mapColorSwatchesFromAttributeValues = (items = []) =>
  parseColorOptionsFromAttributeValues(items).map(({ type, value }) => ({ type, value }));
